import { useSearchScrollPosition } from "./useSearchScrollPosition";

export const SearchScrollPositionInitializer = ({
	namespace,
}: {
	namespace: string;
}) => {
	useSearchScrollPosition(namespace);

	return null;
};
